import { Controller } from '@hotwired/stimulus'

// This controller is used to lazy load a remote script from a URL
// Injects the script into the body of the page if it doesn't already exist
export default class extends Controller {
    static values = {
        scriptUrl: String,
        scriptId: String,
    }

    connect() {
        this.lazyLoadScript()
    }

    lazyLoadScript() {
        const isLoaded = document.getElementById(this.scriptIdValue)
        if (isLoaded) {
            return
        }

        const newScript = document.createElement('script')
        newScript.src = this.scriptUrlValue
        newScript.id = this.scriptIdValue
        newScript.setAttribute('defer', '')
        document.body.appendChild(newScript)
    }
}
